<div class="modal-container edit-saved-cart-modal-container">
  <div class="modal-content">
    <div class="modal-header d-flex align-items-center">
      <h4 class="modal-title">{{ 'cart.editCartsModal.title' | cxTranslate }}</h4>
      <button class="close" aria-label="Close" (click)="closeModal()">
        <mat-icon svgIcon="modal-x-icon"></mat-icon>
      </button>
    </div>
    <div class="modal-body">
      <app-dynamic-form
        (formGroupEmit)="updateFormGroup($event)"
        (formModelEmit)="updateFormModel($event)"
        [formGroupId]="'SAVE_CART_MODAL_FORM'"
        [values]="values"
        [static]="true"
      ></app-dynamic-form>
    </div>
    <div class="modal-footer justify-content-sm-between justify-content-md-end">
      <button type="button" class="btn secondary-btn" (click)="closeModal()">
        {{ 'cart.editCartsModal.cancel' | cxTranslate }}
      </button>
      <button
        type="button"
        class="btn primary-btn"
        [ngClass]="activeLanguage$ | async"
        (click)="updateCartDetails(formGroup)"
        [class.disabled]="disabled"
        [disabled]="disabled"
      >
        {{ 'cart.editCartsModal.save' | cxTranslate }}
      </button>
    </div>
  </div>
</div>
